export default "__VITE_ASSET__Qgdsd8R9__"